/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * <p>
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 * <p>
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 *
 * This is the data class for holding partner attributes.
 *
 */

import React from 'react';
import '../../form-elements/formElement.css';
import API from "../../../../../utils/api";
import EventEmitter from "../../../../../eventEmmiters/EventEmitter";
import FormElementGenerator from "../../form-elements/formElementGenerator";
import Loader from "../../../loader/loader";

/**
 * HOC for the Course Unpairing form
 */
class InstitutionUnblockForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            institutionId: null,
            name: '',
            partnerId: null,
            partnerName: '',
            organizationId: '',
            courseCreationBlocked: '',
            courseCreationBlockedStartDate: '',
            courseCreationBlockedEndDate: '',
            isDisplayLoader: true,
            errors: {},
            token: '',
            fields: [
                {
                    inputType: 'text',
                    labelName: 'Institution Name',
                    inputName: 'name',
                    required: true,
                    disabled: true,
                },
                {
                    inputType: 'text',
                    labelName: 'Partner Name',
                    inputName: 'partnerName',
                    required: true,
                    disabled: true
                },
                {
                    inputType: 'text',
                    labelName: 'Organization Id',
                    inputName: 'organizationId',
                    required: true,
                    disabled: true
                },
                {
                    inputType: 'dropdown',
                    labelName: 'Course Creation Blocked Enabled *',
                    inputName: 'courseCreationBlocked',
                    optionValueName: 'courseCreationBlocked',
                    optionLabelName: 'courseCreationBlockedName',
                    required: true,
                    path: null,
                    valueType: 'basic'
                },

                {
                    inputType: 'datetime-local',
                    labelName: 'Blocked Start Date *',
                    inputName: 'courseCreationBlockedStartDate',
                    optionValueName: 'courseCreationBlockedStartDate',
                    optionLabelName: 'courseCreationBlockedStartDate',
                    valueType: 'startDate'
                }
            ]
        };


        const institutionId = this.props.match.params.id;

        if (institutionId === undefined) {
            EventEmitter.emit('setPageHeaderData', {
                page: 'institutionUnblock',
                pageName: "Institution Unblock",
                pageLink: process.env.REACT_APP_BASE_URL + "/#/home/institutionUnblock",
                optionalIcons: ['backIcon','clearFormIcon']
            });
        } else {
            EventEmitter.emit('setPageHeaderData', {
                page: 'institutionUnblock',
                pageName: "Course Creation Block / Unblock",
                pageLink: process.env.REACT_APP_BASE_URL + "/#/home/institutionUnblock",
                optionalIcons: ['backIcon']
            });
        }

        EventEmitter.on('saveFormData', this.handleSubmit);
        EventEmitter.on('displayDeleteFormDataWarning', this.displayDeleteWarningMessage);
        EventEmitter.on('navigateToPreviousPage', this.navigateToPreviousPage);
    }


    componentDidMount = async () => {
        const institutionId = this.props.match.params.id;
        const user = JSON.parse(localStorage.getItem('tmcUser'));
        const token = 'Bearer ' + user.token;
        const oldState = Object.assign({}, this.state);

        if (institutionId !== undefined) {
            const url = '/unblock-institutions?search=%7BinstitutionId:' + institutionId + '%7D';
            await API.get(url, {headers: {Authorization: token}})
                .then(res => {
                    const data = res.data[0];
                    oldState.institutionId = data.institutionId || null;
                    oldState.name = data.name || '';
                    oldState.partnerId = data.partnerId || null;
                    oldState.partnerName = data.partnerName || '';
                    oldState.organizationId = data.organizationId || '';
                    oldState.courseCreationBlocked = data.courseCreationBlocked;
                    oldState.courseCreationBlockedStartDate = data.courseCreationBlockedStartDate || '';
                    oldState.courseCreationBlockedEndDate = data.courseCreationBlockedEndDate || '';
                    oldState.token = token;
                    oldState.isDisplayLoader = false;
                    this.setState(oldState);
                }).catch(err => {
                    oldState.isDisplayLoader = false;
                    this.setState(oldState);
                    this.displayErrorsForAPICalls(err);
                });
        } else {
            oldState.token = token;
            oldState.isDisplayLoader = false;
            this.setState(oldState);
        }
    };

    componentWillUnmount = () => {
        EventEmitter.off('setPageHeaderData', {});
        EventEmitter.off('saveFormData', this.handleSubmit);
        EventEmitter.off('displayDeleteFormDataWarning', this.displayDeleteWarningMessage);
        EventEmitter.off('navigateToPreviousPage', this.navigateToPreviousPage);
    };

    handleChange = event => {
        if (event.optionValueName !== undefined) {
            this.setState({
                [event.optionValueName]: event.value,
                [event.optionLabelName]: event.label
            }, () => {
                this.validate(event.optionValueName, event.value)
            });
        } else {
            const key = event.currentTarget.name;
            const val = event.currentTarget.value;
            this.setState({
                [key]: val
            }, () => {
                this.validate(key, val)
            });
        }
    };

    handleSubmit = () => {
        console.log("data")
        let data;
        let formattedStartDate;
        if (this.state.institutionId !== null) {
            // Ensure the Blocked Start Date includes a default time
            if(this.state.courseCreationBlocked != false){
                const rawStartDate = this.state.courseCreationBlockedStartDate;
                 formattedStartDate = rawStartDate && rawStartDate.includes('T')
                    ? rawStartDate // If date already includes a time
                    : `${rawStartDate}T00:00:00`; // Append default time if missing
            }

            data = {
                institutionId: this.state.institutionId,
                name: this.state.name,
                partnerId: this.state.partnerId,
                partnerName: this.state.partnerName,
                organizationId: this.state.organizationId,
                courseCreationBlocked: this.state.courseCreationBlocked,
                courseCreationBlockedStartDate: this.state.courseCreationBlocked === true ? formattedStartDate : null,
                courseCreationBlockedEndDate: this.state.courseCreationBlockedEndDate
            };
        } else {
            data = {
                name: this.state.name,
                partnerId: this.state.partnerId,
                partnerName: this.state.partnerName,
                organizationId: this.state.organizationId,
                courseCreationBlocked: this.state.courseCreationBlocked,
                courseCreationBlockedStartDate: this.state.courseCreationBlockedStartDate,
                courseCreationBlockedEndDate: this.state.courseCreationBlockedEndDate
            };
        }

        for (let [key, value] of Object.entries(data)) {
            this.validate(key, value);
        }
        console.log("data set",this.state.courseCreationBlocked)
        if (Object.values(this.state.errors).find(o => o !== '') === undefined) {
            if (this.state.institutionId !== null) {
                this.updateInstitution(data);
            }
        }
    };

    validate = (key, value) => {
        let error = {};
        switch (key) {
            case 'courseCreationBlockedStartDate':
                if(value !=null){
                    const [date] = value.split('T'); // Extract only the date part
                    if (!date || date.trim() === '') {
                        error[key] = "Blocked Start Date is Required!";
                    } else {
                        error[key] = "";
                    }
                }
                break;

            default:
                break;
        }
        const newState = Object.assign({}, this.state);
        newState.errors = Object.assign(newState.errors, error);
        this.setState(newState);
    };


    updateInstitution = async (data) => {
        console.log("updateInstitution",this.state.token)
        await API.put('/unblock-institutions',
            data,
            {headers: {Authorization: this.state.token}}
        ).then(response => {
            this.setAlert("Success", "Success", "Successfully Updated");
            this.props.history.push('/home/institutionUnblock');
        }).catch(er => {
            this.displayErrorsForAPICalls(er);
        });
    };


    displayErrorsForAPICalls = (error) => {
        if (error.response !== undefined && error.response.status === 404) {
            this.setAlert("Error", "Error", "The selected item not found!");
        } else if (error.message.includes('422')) {
            this.setAlert("Error", "Sorry", "Institution already exists!");
        } else if (error.response === undefined || error.response.status === 401) {
            localStorage.removeItem('tmcUser')
            this.props.history.push('/');
        } else {
            this.setAlert("Error", "Error", "Something went wrong");
        }
    };

    setAlert = (alertType, alertTitle, alertMessage) => {
        EventEmitter.emit('setAlert', {
            openAlert: true,
            type: alertType,
            isDisplayAlertIcon: true,
            alertMessage: alertMessage,
            alertTitle: alertTitle
        });
    };


    navigateToPreviousPage = () => {
        this.props.history.push('/home/institutionUnblock');
    };

    render() {

        // Filter fields based on the value of courseCreationBlocked
        const visibleFields = this.state.fields.filter((field) => {
            if (
                field.inputName === 'courseCreationBlockedStartDate' &&
                (this.state.courseCreationBlocked === 'No' ||
                    this.state.courseCreationBlocked === false ||
                    this.state.courseCreationBlocked === null)
            ) {
                return false; // Exclude the Blocked Start Date field
            }
            return true; // Include all other fields
        });

        return(
            <div role="form" className="container">
                {this.state.isDisplayLoader && <Loader/>}
                <div className="main-btn-container">
                    <div className="buttons" tooltip="Save" onClick={this.handleSubmit}>
                        <i className="fa fa-save fa-lg icon-primary" />
                    </div>
                </div>
                <form>
                    {/* Pass the filtered fields to the FormElementGenerator */}
                    <FormElementGenerator
                        currentState={{ ...this.state, fields: visibleFields }}
                        handleChange={this.handleChange}
                    />
                </form>
            </div>
        )
    }
}

export default InstitutionUnblockForm;
